import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { AppConstant } from "src/app/app.constant";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { DataResult, DataSourceRequestState } from "@progress/kendo-data-query";

@Injectable()
export class AcademicYearService {
    apiUrl: string;
    kendoDataUrl: string;
    constructor(private httpClient: HttpClient,
        private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl()
    }
    manageAcademicYear(academicYear) {
        return this.httpClient.post(`${this.apiUrl}/manageAcademicYear`, academicYear).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    refreshToken(academicYear) {
        return this.httpClient.post(`${this.apiUrl}/refresh-token/academic-year`, academicYear).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    getAcademicYearById(academicYearId) {
        return this.httpClient.get(`${this.apiUrl}/getAcademicYearById/`+ academicYearId).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
  public getAllAcademicYear(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllAcademicYear`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    public getAllAcademicYearNames(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllAcademicYearName`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
}